import { render } from "./PostModal.vue?vue&type=template&id=eb0cda1c&ts=true"
import script from "./PostModal.vue?vue&type=script&lang=ts"
export * from "./PostModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__